angular.module('core')
    .component('tableStatusFilter', {
        bindings: {
            statistics: '<',
            filters: '<',
            langKey: '@',
            btnClass: '@',
            nullable: '<?',
            emptyFilterSelectedAll: '<?'
        },
        template: `
            <div class="status-filter-block" ng-if="$ctrl.hasStatuses()">
                <div class="select-all-button" ng-if="$ctrl.hasStatuses()"><i class="fa fa-fw fa-circle-o" ng-click="$ctrl.toggleSelectAllStatus($ctrl.filters.status, $ctrl.statistics.status)" uib-tooltip="Zaznacz wszystko / Domyślny"></i></div>
                <button ng-if="$ctrl.nullable === true" type="button"
                        class="btn btn-sm btn-primary {{$ctrl.btnClass}} NULL"
                        ng-class="{ 'not-filtered-status': $ctrl.filters.statusNull === false || $ctrl.filters.statusNull == null }"
                        sglclick="$ctrl.statusNullSingleClick()"
                        ng-dblclick="$ctrl.statusNullDoubleClick()"
                        title="{{ $ctrl.langKey + '.NULL.help' | translate}}">
                    {{ ($ctrl.langKey + '.NULL') | translate }}<span ng-if="$ctrl.isNumber($ctrl.statistics.statusNull)">&nbsp;&nbsp;<span class="badge" style="font-size: smaller;">{{$ctrl.statistics.statusNull}}</span></span>
                </button>
                <button ng-repeat="(status, count) in $ctrl.statistics.status" type="button"
                        class="btn btn-sm btn-primary {{$ctrl.btnClass}} {{status}}"
                        ng-class="{ 'not-filtered-status': (!$ctrl.filters.status.includes(status) && $ctrl.filters.status.length > 0) || ($ctrl.emptyFilterSelectedAll === true && $ctrl.filters.status.length === 0 ) }"
                        sglclick="$ctrl.statusSingleClick($ctrl.filters.status, status)"
                        ng-dblclick="$ctrl.statusDoubleClick(status)"
                        title="{{ $ctrl.langKey + '.' + status + '.help' | translate}}">
                    {{ ($ctrl.langKey + '.' + status) | translate }}<span ng-if="$ctrl.isNumber(count)">&nbsp;&nbsp;<span class="badge" style="font-size: smaller;">{{count}}</span></span><span ng-if="$ctrl.isArray(count)">&nbsp;&nbsp;<span ng-repeat="subArray in count" class="badge table-statistics property-deal {{subArray.name}}" title="{{ ('property-deal.agreement-type.'+subArray.name)|translate }}">{{subArray.count}}</span></span>
                </button>
            </div>
        `,
        controller: function ($scope, $state) {
            this.$onInit = () => {
                this.emptyFilterSelectedAll = this.emptyFilterSelectedAll || true
            }
            this.hasStatuses = () => {
                return this.statistics != null && Object.keys(this.statistics.status).length > 0
            }
            this.isNumber = (value) => {
                return typeof value === 'number' && isFinite(value);
            }
            this.isObject = (value) => {
                return typeof value === 'object' && value !== null;
            }
            this.isArray = (value) => {
                return Array.isArray(value);
            }
            this.statusNullSingleClick = () => {
                if (this.filters.statusNull == null)
                    this.filters.statusNull = true;
                else
                    this.filters.statusNull = this.filters.statusNull !== true;

                $state.go($state.current, this.filters, {inherit: false, reload: false, notify: true})
            }
            this.statusNullDoubleClick = () => {
                this.filters.statusNull = true
                this.filters.status = []
                $state.go($state.current, this.filters, {inherit: false, reload: false, notify: true})
            }
            this.statusSingleClick = (activeStatuses, status) => {
                if (Array.isArray(activeStatuses) && activeStatuses.includes(status))
                    this.filters.status.splice(this.filters.status.indexOf(status), 1)
                else {
                    if (!Array.isArray(this.filters.status)) {
                        this.filters.status = []
                    }
                    this.filters.status.push(status)
                }
                $state.go($state.current, this.filters, {inherit: false, reload: false, notify: true})
            }
            this.statusDoubleClick = (status) => {
                if(this.nullable === true) {
                    this.filters.statusNull = false
                }
                this.filters.status = [status]
                $state.go($state.current, this.filters, {inherit: false, reload: false, notify: true})
            }
            this.toggleSelectAllStatus = (selected, statusesStatistics) => {
                let all = Object.keys(statusesStatistics)
                let checker = (arr, target) => target.every(v => arr.includes(v))
                if (checker(selected, all)) {
                    this.filters.status = []
                    if(this.nullable === true) {
                        delete this.filters.statusNull
                    }
                } else {
                    this.filters.status = all
                    if(this.nullable === true) {
                        this.filters.statusNull = true
                    }
                }
                $state.go($state.current, this.filters, {inherit: false, reload: false, notify: true})
            }
        }
    })
